import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, KeyCloakAuthService } from '@fgb/core';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-key-cloak-callback',
  templateUrl: './key-cloak-callback.component.html',
  styleUrls: ['./key-cloak-callback.component.scss'],
})
export class KeyCloakCallbackComponent implements OnInit {
  cookieName: string = '_sa_sso_upid';
  constructor(
    private keyCloakAuthService: KeyCloakAuthService,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      // already logged in
      this.router.navigate(['/']);
    } else if (this.keyCloakAuthService.hasNamedCookie(this.cookieName)) {
      // login through cookies
      let domainCookie = this.getDomainCookie();
      this.authenticateDomainCookie(domainCookie);
    } else {
      // log through a code
      this.authenticateCode();
    }
  }

  /**
   * make request to authenticate domain
   * cookie if found.
   * If failed then will call authenticate JWT.
   * @param domainCookie domain cookie to
   * be authenticated.
   */
  authenticateDomainCookie(domainCookie: string) {
    firstValueFrom(this.keyCloakAuthService.loginUsingToken(domainCookie)).catch(() => {
      this.authenticateCode();
    });
  }

  /**
   * call to athenticate JWT
   * if failed response will return
   * user to login page.
   */
  authenticateCode() {
    let kccode = this.getProviderCodeToken('code');
    firstValueFrom(this.keyCloakAuthService.validateCode(kccode)).catch(() => {
      this.router.navigate(['/login']);
    });
  }

  /**
   * Get a query string parameter without case sensitivity.
   * @param parameter the parameter that you require the information for
   */
  getProviderCodeToken(parameter: string): string {
    const url = window.location.href;
    let paramValue;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(parameter);
    }

    if (paramValue) {
      return paramValue;
    }
    return '';
  }

  /**
   * Will check if domain cookie exists
   * and return this as a string.
   * @returns domain cookie from
   * sports alliance domain
   */
  getDomainCookie(): string {
    let domainCookie = '';
    domainCookie = this.cookieService.get(this.cookieName);

    return domainCookie;
  }
}
